/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SortDirection } from '../../models/sort-direction';
import { StationConnectivityList } from '../../models/station-connectivity-list';

export interface GetAllConnectivityStation$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * The station service type for filter
 */
  serviceTypes?: Array<'IN_USE' | 'IN_USE_WITH_RESTRICTIONS' | 'STOPPED' | 'UNDER_CONSTRUCTION' | 'PLANNING_STAGE'>;

/**
 * The station state for filter
 */
  stationHealthState?: 'GOOD' | 'BAD' | 'UNKNOWN';
}

export function getAllConnectivityStation(http: HttpClient, rootUrl: string, params?: GetAllConnectivityStation$Params, context?: HttpContext): Observable<StrictHttpResponse<StationConnectivityList>> {
  const rb = new RequestBuilder(rootUrl, getAllConnectivityStation.PATH, 'get');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('serviceTypes', params.serviceTypes, {"style":"form","explode":false});
    rb.query('stationHealthState', params.stationHealthState, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StationConnectivityList>;
    })
  );
}

getAllConnectivityStation.PATH = '/stations-connectivity';
